import axios from 'axios'

const service = axios.create({
    baseURL: 'http://bjtstd.com.cn',

  timeout: 100000, //超时时间
})

export default service
